import HomeOutlined from '@mui/icons-material/HomeOutlined';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import type { NavItemProps } from '../CustomNavLink';

const Home = ({ ActiveComp }: NavItemProps) => (
  <Box
    sx={(theme) => ({
      alignItems: 'center',
      borderLeft: `1px solid ${theme.palette.divider}`,
      color: ActiveComp ? theme.palette.primary.main : 'inherit',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      padding: '1rem',
    })}
  >
    <IconButton size="small" color="inherit">
      <HomeOutlined />
    </IconButton>
    {ActiveComp && <ActiveComp />}
  </Box>
);

export default Home;
